<template>
	<div class="NewLists-div">
		<div class="NewLists-top">
			<Navbar></Navbar>
		</div>
    <div class="NewLists-banner">
      <img src="../assets/images/banner2.png" />
    </div>
    <div class="NewLists-content">
      <div class="NewLists-content-div">
        <div class="NewLists-con-news">
          <template v-if="articleObj">
            <ul class="NewLists-con-newsul">
              <li v-for="(listitem, itemindex) in articleObj.data"
                  :key="itemindex"
                  class="NewLists-con-newsli">
                <router-link class="NewLists-con-newslink" :to="`/NewDetail?id=${listitem.id}`">
                  <img :src="listitem.pic" class="NewLists-newsli-img">
                  <div class="NewLists-newsli-con">
                    <div class="NewLists-newsli-title">{{listitem.title}}</div>
                    <div class="NewLists-newsli-msg">{{listitem.introduction}}</div>
                  </div>
                  <div class="NewLists-newsli-time">
                    {{listitem.createTime}}
                  </div>
                </router-link>
              </li>
            </ul>
            <div style="display: flex; justify-content: center;">
              <el-pagination v-if="articleObj.totalRecords > 0"
                @current-change="currentChange"
                background
                layout="prev, pager, next"
                :total="articleObj.totalRecords">
              </el-pagination>
            </div>
          </template>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import request from "../util/request";
	import Navbar from "../components/Navbar.vue";
	export default {
		name: "NewLists",
		components: {
			Navbar
		},
		data() {
		  return {
        activeindex: -1, // 鼠标移入的
        showindex: 0, // 展示的新闻列表
        newslist:[],

        page: {
          pageIndx: 1
        },
        articleObj: null,
		  }
		},
    mounted() {
      this.getList()
    },
    watch: {
      $route() {
        this.getList()
      }
    },
    methods: {
      currentChange(pageIndex) {
        this.page.pageIndx = pageIndex
        this.getList()
      },
      async getList() {
        let articleObj = await request.get(`/article/list?keywords=${this.$route.query.keywords}&pageIndex=${this.page.pageIndx}&pageSize=10`)
        this.articleObj = articleObj
      },
      showactive(num) {
        this.activeindex = num;
      },
      hideactive() {
        this.activeindex = -1;
      },
      shownewlist(num) {
        this.showindex = num;
      }
    }
	}
</script>

<style scoped>
  .NewLists-banner {
    width: 100%;
    min-width: 1200px;
    height: 350px;
  }
  
  .NewLists-banner img {
    width: 100%;
    height: 100%;
  }
  
  .NewLists-content {
    min-width: 1200px;
    background-color: #f5f5f5;
  }
  
  .NewLists-content-div {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }
  
  .NewLists-con-tab,
  .NewLists-con-news {
    background-color: #fff;
    border-radius: 10px;
    overflow: hidden;
  }
  
  .NewLists-con-tab {
    margin-right: 10px;
    width: 180px;
    min-height: 250px;
    flex-shrink: 0;
  }
  
  .NewLists-con-tabtitle {
    font-size: 16px;
    font-weight: bold;
    color: #262626;
    padding: 10px 15px;
    box-sizing: border-box;
  }
  
  .NewLists-con-tabli {
    color: #787878;
    background-color: #f5f5f5;
    padding: 10px 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #fff;
    cursor: pointer;
    position: relative;
  }
  
  .NewLists-con-tabli-moveactive {
    color: #232CEA;
    background-color: rgba(35, 44, 234, 0.10);
  }
  
  .NewLists-con-tabli-active {
    color: #232CEA;
    font-weight: bold;
  }
  
  .NewLists-con-tabli-active::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    width: 2px;
    height: 100%;
    z-index: 1;
    background: #232cea;
  }
  
  .NewLists-con-news {
    flex-grow: 2;
    padding: 12px;
    box-sizing: border-box;
  }
  
  .NewLists-con-newsli {
    padding: 12px;
    box-sizing: border-box;
    background-color: #f5f5f5;
    margin-bottom: 12px;
  }
  
  .NewLists-con-newslink {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-decoration: none;
  }
  
  .NewLists-newsli-img {
    width: 150px;
    height: 80px;
    border-radius: 10px;
  }
  
  .NewLists-newsli-con {
    margin-left: 12px;
    margin-right: 12px;
    flex-grow: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .NewLists-newsli-title {
    color: #262626;
    font-weight: bold;
    font-size: 18px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
  
  .NewLists-newsli-msg {
    font-size: 14px;
    color: #787878;
    margin-top: 12px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  
  .NewLists-newsli-time {
    color: #787878;
    border-left: 1px solid #787878;
    padding: 5px 12px;
    box-sizing: border-box;
    width: 140px;
  }
</style>